import {checkEmptyData} from '../../../utils/helper'
interface Props {
  products: any
  isMixMatch: boolean
}
const ProductDetails = ({products, isMixMatch}: Props) => {
  console.log('product', products)
  return (
    <>
      <label className='d-flex align-items-center fs-5 fw-bold mb-4 lh-1'>
        <span>Product Details</span>
      </label>
      <div className='fs-6 fw-semibold  mb-2'>
        Product Name : <span className='ms-1 fw-semibold '>{products?.name}</span>
      </div>
      {(products?.commodity?.name === 'Electric' ||
        products?.commodity?.name === 'Dual' ||
        isMixMatch) && (
        <table className='table table-rounded table-striped border mb-2 gy-7 gs-7'>
          <tbody>
            <tr>
              <td className='fs-6 fw-semibold'>E_Rate</td>
              <td className='fs-6 fw-semibold'>E_Term</td>
              <td className='fs-6 fw-semibold'>E_Service Fee</td>
              <td className='fs-6 fw-semibold'>E_Termination Fee</td>
              <td className='fs-6 fw-semibold'>E_Product Code</td>
            </tr>
            <tr>
              <td>
                {Boolean(products?.rate) && '$'} {checkEmptyData(products?.rate)}
              </td>
              <td>{checkEmptyData(products?.term)}</td>
              <td>
                {Boolean(products?.serviceFee) && '$'}{' '}
                {checkEmptyData(products?.earlyTerminationFee)}
              </td>
              <td>
                {Boolean(products?.serviceFee) && '$'} {checkEmptyData(products?.serviceFee)}
              </td>
              <td>{checkEmptyData(products?.ecode)}</td>
            </tr>
          </tbody>
        </table>
      )}
      {(products?.commodity?.name === 'Gas' ||
        products?.commodity?.name === 'Dual' ||
        isMixMatch) && (
        <table className='table table-rounded table-striped border mb-2 gy-7 gs-7'>
          <tbody>
            <tr>
              <td className='fs-6 fw-semibold'>G_Rate</td>
              <td className='fs-6 fw-semibold'>G_Term</td>
              <td className='fs-6 fw-semibold'>G_Service Fee</td>
              <td className='fs-6 fw-semibold'>G_Termination Fee</td>
              <td className='fs-6 fw-semibold'>G_Product Code</td>
            </tr>
            <tr>
              <td>
                {Boolean(products?.grate) && '$'} {checkEmptyData(products?.grate)}
              </td>
              <td>{checkEmptyData(products?.gterm)}</td>
              <td>
                {Boolean(products?.gearlyTerminationFee) && '$'}{' '}
                {checkEmptyData(products?.gearlyTerminationFee)}
              </td>
              <td>
                {Boolean(products?.gserviceFee) && '$'} {checkEmptyData(products?.gserviceFee)}
              </td>
              <td>{checkEmptyData(products?.gcode)}</td>
            </tr>
          </tbody>
        </table>
      )}
    </>
  )
}

export default ProductDetails
